"use client";

import dynamic from "next/dynamic";

// Client boundary so dynamic() actually code-splits. SubscribeButton is a
// client component pulled in by the server block AdvancedPricing; importing it
// through this wrapper gives it its own chunk instead of riding along in every
// route's bundle. (dynamic() called directly inside the server block does not
// split — the client child still gets bundled.)
export default dynamic(() => import("../SubscribeButton"));
